import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#home", label: "Home" },
  { href: "#how-it-works", label: "How it works" },
  { href: "#for-vendors", label: "For vendors" },
  { href: "#for-drivers", label: "For drivers" },
  { href: "#faq", label: "FAQ" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="liea-nav"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        background: scrolled
          ? "rgba(251, 247, 241, 0.85)"
          : "rgba(251, 247, 241, 0.0)",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        borderBottom: scrolled
          ? "1px solid rgba(149, 159, 133, 0.18)"
          : "1px solid transparent",
      }}
    >
      <div className="liea-container flex items-center justify-between h-[72px]">
        <a
          href="#home"
          data-testid="liea-logo"
          className="liea-mark text-2xl md:text-[26px]"
          style={{ color: "var(--liea-forest)" }}
        >
          LIÉA<span className="dot">.</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium transition-colors"
              style={{ color: "var(--liea-warm-grey)" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.color = "var(--liea-forest)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "var(--liea-warm-grey)")
              }
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#for-customers"
            data-testid="nav-cta-download"
            className="liea-btn-accent inline-flex items-center px-5 py-2.5 rounded-full text-sm font-medium"
          >
            Get the app
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 rounded-full"
          style={{ color: "var(--liea-forest)" }}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="lg:hidden"
          style={{
            background: "var(--liea-paper)",
            borderTop: "1px solid rgba(149, 159, 133, 0.18)",
          }}
        >
          <div className="liea-container py-5 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium"
                style={{ color: "var(--liea-forest)" }}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#for-customers"
              onClick={() => setOpen(false)}
              className="liea-btn-accent inline-flex items-center justify-center px-5 py-3 rounded-full text-sm font-medium mt-2"
            >
              Get the app
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
